import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const CommunityImpactBuilder = ({ feedbacksTitle, feedbacksHome }) => {
  const settings = {
    dots: false,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '140',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0',
        },
      },
    ],
  };

  return (
    <div className='communityimpact-wrap slick-slider-arrow'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <figure className='c-impact-icon'>
              <StaticImage src='../../images/community-icon.png' alt='image' />
            </figure>
            <h2 className='heading-level-2 blue-color text-center'>
              {feedbacksTitle}
            </h2>
          </div>
        </div>
      </div>
      <div className='container-fluid'>
        <Slider {...settings}>
          {feedbacksHome.map((item, index) => (
            <div key={index}>
              <div className='community-slide-box'>
                <div className='row'>
                  <div className='col-md-2'>
                    <figure>
                      <StaticImage
                        src='../../images/community-slide-icon.png'
                        alt='image'
                      />
                    </figure>
                  </div>
                  <div className='col-md-10'>
                    <h3 className='heading-level-4 blue-color mb-2'>
                      {item.slider1SlideTitle}
                    </h3>
                    <p>{item.slider1SlideSubtitle}</p>
                  </div>
                  <div className='col-md-12'>
                    <p>{item.slider1SlideText}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CommunityImpactBuilder;
